import React from 'react';
import { graphql } from 'gatsby';
import getBlogData from '../../normalization/blog';
import LayoutContainer from '../../containers/layout';
import SEO from '../../components/seo';
import TextComponent from '../../components/TextComponent/textComponent';
import {
  BilateralContainerLayoutStyleListTypes,
  TextComponentLayout,
  getFeaturedContent,
  nonFeaturedContentFromList,
  ALL_CATEGORIES_DEFAULT,
} from '../../utils/utils';
import BilateralContainerLayout from '../../components/Bilateral/BilateralContainerLayout/bilateralContainerLayout';
import './index.scss';
import CategorieDropdown from '../../components/CategorieDropdown/categorieDropdown';
import MediaContentBlock from '../../components/MediaContentBlock/mediaContentBlock';
import FeaturedContent from '../../components/FeaturedContent/featuredContent';

export const query = graphql`
  query BLOGSEOQuery {
    allSanitySeoSchema(filter: { PageSlug: { eq: "blog" } }) {
      edges {
        node {
          SEOSchema
          PageSlug
        }
      }
    }
    site: sanitySiteSettings(_id: { regex: "siteSettings/" }) {
      title
      description
      keywords
    }
  }
`;

const BlogIndexPage = (props) => {
  const blogPageSchema = JSON.parse(props.data.allSanitySeoSchema.edges[0].node.SEOSchema);
  const [blogCategory, setBlogCategory] = React.useState(ALL_CATEGORIES_DEFAULT);
  const [isFeaturedBlogShow, setFeaturedBlogShow] = React.useState(true);
  const defaultItem = { text: 'Sort By', value: ALL_CATEGORIES_DEFAULT };

  const handleSort = (selectedSort) => setBlogCategory(selectedSort);

  const result = getBlogData();
  const categories = result.filterList;
  const allBlogs = result.blogData;

  // this contains only featured blog
  const featuredArticle = getFeaturedContent(allBlogs);
  // this contains all blogs except for non-featured due to duplication
  const nonFeaturedBlogs = nonFeaturedContentFromList(allBlogs, featuredArticle.id);

  const { data } = props;
  const { site } = data || {};
  React.useEffect(() => {
    if (blogCategory !== ALL_CATEGORIES_DEFAULT) {
      setFeaturedBlogShow(false);
    } else {
      setFeaturedBlogShow(true);
    }
  }, [blogCategory]);

  return (
    <LayoutContainer>
      <SEO title="Blogs" />
      <SEO title={`${site.title} | Blogs`} description={site.description} keywords={site.keywords} schemaMarkup={blogPageSchema} />
      <div className="blogs-wrapper">
        <BilateralContainerLayout layoutStyle={BilateralContainerLayoutStyleListTypes.BILATERALSTYLE5}>
          <div className="sorting-wrap">
            <TextComponent heading="Blog" layoutStyle={TextComponentLayout.LEFT} />
            <CategorieDropdown categories={categories} onSelectCategory={handleSort} defaultItem={defaultItem} />
          </div>
          {isFeaturedBlogShow ? <FeaturedContent featuredData={featuredArticle} /> : null}
        </BilateralContainerLayout>
        <div className="container">
          <div className="media-categories">
            <MediaContentBlock mediaData={isFeaturedBlogShow ? nonFeaturedBlogs : allBlogs} selectedCategory={blogCategory} dataLimit={6} isBlogs />
          </div>
        </div>
      </div>
    </LayoutContainer>
  );
};
export default BlogIndexPage;
